// Module
var code = "<div style=\"text-align:right\"> <a ui-sref=\"accounts.list\"><i class=\"fa fa-list\"></i> Account List</a> </div> ";
// Exports
module.exports = code;